module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-minus-bbfb08fd.svg";